/* Gluca Water Filter mini-cart: open/close, line edits, free gifts per bundle,
   filter auto-refill toggle (selling plans), and checkout. */
(function () {
  if (window.gwfCart) return;
  var CFG = window.GWF_CART || { variants: {}, gifts: {}, refills: {}, legacy: [] };
  var root = null, cart = null, busy = false, codeTried = false;
  var LEGACY = CFG.legacy || [];

  var money = function (cents) {
    var v = Math.round(cents) / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };
  var q = function (sel) { return root.querySelector(sel); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function request(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    });
  }
  function load() { return request('/cart.js').then(function (c) { cart = c; paint(); return c; }); }
  function change(line, extra) {
    if (busy) return Promise.resolve();
    busy = true;
    var body = { id: line.key, quantity: line.quantity };
    for (var k in extra) body[k] = extra[k];
    return request('/cart/change.js', body)
      .then(function (c) { cart = c; paint(); })
      .catch(function () { return load(); })
      .then(function () { busy = false; });
  }

  function meta(item) { return CFG.variants[String(item.variant_id)] || null; }
  function realItems() { return (cart && cart.items || []).filter(function (i) { return LEGACY.indexOf(i.variant_id) < 0; }); }
  function thumb(item) {
    var u = item.image || '';
    return u ? u.split('?')[0].replace(/(\.(png|jpe?g|webp|gif))$/i, '_200x$1') : '';
  }
  function addBusinessDays(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function etaText() {
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    return 'Order today, arrives <b>' + fmt(addBusinessDays(5)) + '–' + fmt(addBusinessDays(7)) + '</b>';
  }

  /* Old store lines (shipping protection, old gifts) are removed quietly */
  function dropLegacy() {
    var old = (cart && cart.items || []).filter(function (i) { return LEGACY.indexOf(i.variant_id) >= 0; });
    if (!old.length) return;
    var updates = {};
    old.forEach(function (i) { updates[i.key] = 0; });
    request('/cart/update.js', { updates: updates }).then(function (c) { cart = c; paint(); }).catch(function () {});
  }

  // This store runs no discount codes. Remove any code left over from an earlier session
  // (for example the old GLUCA10 welcome offer) so it never shows in the cart or checkout.
  function dropCodes() {
    if (codeTried || !(cart.discount_codes || []).length) return;
    codeTried = true;
    request('/cart/update.js', { discount: '', attributes: { _welcome_offer: '' } }).then(load).catch(function () {});
  }

  function itemHtml(i) {
    var m = meta(i);
    var was = m && m.compareAt > i.original_price ? m.compareAt * i.quantity : 0;
    var save = was ? was - i.final_line_price : 0;
    var vt = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
    var sub = i.selling_plan_allocation ? '<p class="gmc__sub">&#8635; Auto-refill on</p>' : '';
    var html = '<div class="gmc__item" data-key="' + esc(i.key) + '">'
      + (thumb(i) ? '<img class="gmc__thumb" src="' + esc(thumb(i)) + '" alt="" loading="lazy" width="76" height="76">' : '<span class="gmc__thumb"></span>')
      + '<div><p class="gmc__iname">' + esc(i.product_title) + '</p>'
      + (vt ? '<p class="gmc__ivar">' + esc(vt) + '</p>' : '') + sub
      + '<span class="gmc__qty"><button type="button" data-gmc-dec aria-label="Decrease quantity">&minus;</button><span>' + i.quantity + '</span><button type="button" data-gmc-inc aria-label="Increase quantity">+</button></span></div>'
      + '<div class="gmc__ipr">' + (was ? '<span class="gmc__was">' + money(was) + '</span>' : '')
      + '<span class="gmc__now">' + money(i.final_line_price) + '</span>'
      + (save > 0 ? '<span class="gmc__isave">You save ' + money(save) + '</span>' : '')
      + '<button class="gmc__rm" type="button" data-gmc-rm aria-label="Remove ' + esc(i.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>'
      + '</div></div>';
    var gifts = m ? (CFG.gifts[String(m.position)] || []) : [];
    gifts.forEach(function (g) {
      html += '<div class="gmc__gift">' + (g.img ? '<img src="' + esc(g.img) + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>')
        + '<div><p class="gmc__gift-name">' + esc(g.name) + '</p><span class="gmc__gift-tag">Free gift</span></div>'
        + '<span class="gmc__gift-free">FREE</span></div>';
    });
    return html;
  }

  /* The refill card follows the first bundle in the cart that has a subscription plan */
  function refillLine(items) {
    for (var n = 0; n < items.length; n++) {
      var m = meta(items[n]);
      if (m && m.plan) return { line: items[n], meta: m, info: CFG.refills[String(m.position)] };
    }
    return null;
  }
  function paintRefill(items) {
    var card = q('[data-gmc-refill]'), r = refillLine(items);
    card.hidden = !r || !r.info;
    var renew = q('[data-gmc-renew]');
    renew.hidden = true;
    if (card.hidden) return;
    var on = !!r.line.selling_plan_allocation;
    card.classList.toggle('is-on', on);
    var sw = q('[data-gmc-refill-toggle]');
    sw.classList.toggle('is-on', on);
    sw.setAttribute('aria-checked', on ? 'true' : 'false');
    var today = money(r.line.final_line_price);
    q('[data-gmc-refill-price]').textContent = 'Today ' + today + '. Then ' + r.info.filters + ' every ' + r.info.every + ' for ' + r.info.price + '.';
    q('[data-gmc-refill-desc]').textContent = on
      ? 'Your next filter ships in ' + r.info.every + ', right before this one runs out. We email you before every refill. Skip or cancel anytime, no fees.'
      : 'Turn this on and your next filter ships in ' + r.info.every + ', right before this one runs out. Skip or cancel anytime.';
    if (on) {
      renew.hidden = false;
      renew.textContent = 'You pay ' + today + ' today. Then ' + r.info.price + ' every ' + r.info.every + ' for new filters until you cancel.';
    }
    autoRefill(r, on);
  }

  function refillNote(r) {
    return 'Today you pay ' + money(r.line.final_line_price) + ' for the pitcher bundle. Then ' + r.info.price + ' every ' + r.info.every + ' for ' + r.info.filters.replace('new ', '') + ' (replacement filters only, no pitcher). Skip or cancel anytime.';
  }
  function withNote(line, note) {
    var props = {};
    var cur = line.properties || {};
    for (var k in cur) if (k !== 'Auto-refill') props[k] = cur[k];
    if (note) props['Auto-refill'] = note;
    return props;
  }

  /* Refills start switched off unless GWF_CART.refillDefaultOn is true. If refills start on and the
     customer switches them off, that choice sticks for the visit. */
  var autoTried = {};
  function refillOptedOut() { try { return sessionStorage.getItem('gwfRefillOff') === '1'; } catch (e) { return false; } }
  function autoRefill(r, on) {
    if (!CFG.refillDefaultOn || on || busy || refillOptedOut() || autoTried[r.line.key]) return;
    autoTried[r.line.key] = true;
    change(r.line, { selling_plan: r.meta.plan, properties: withNote(r.line, refillNote(r)) });
  }

  function paint() {
    if (!root || !cart) return;
    var items = realItems();
    var units = items.reduce(function (a, i) { return a + i.quantity; }, 0);
    q('[data-gmc-count]').textContent = units ? '(' + units + ')' : '';
    q('[data-gmc-eta]').innerHTML = etaText();
    var wrap = q('[data-gmc-items]');
    wrap.innerHTML = items.length
      ? items.map(itemHtml).join('')
      : '<div class="gmc__empty"><p>Your cart is empty.</p><a href="/#gwf-offer" data-gmc-close>Choose my bundle</a></div>';
    paintRefill(items);
    q('[data-gmc-trust]').hidden = !items.length;

    var savings = items.reduce(function (a, i) {
      var m = meta(i);
      return a + (m && m.compareAt > i.original_price ? m.compareAt * i.quantity - i.original_line_price : 0);
    }, 0) + (cart.total_discount || 0);
    q('[data-gmc-saverow]').hidden = savings <= 0;
    q('[data-gmc-save]').textContent = '-' + money(savings);

    q('[data-gmc-total]').textContent = money(cart.total_price);
    q('[data-gmc-checkout]').disabled = units === 0;
    badge(units);
    dropLegacy();
    dropCodes();
  }

  var ICON = '<svg class="gmc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1.1 11.2a2 2 0 0 1-2 1.8H9.1a2 2 0 0 1-2-1.8z"/><path d="M9 8V6.2A3 3 0 0 1 12 3a3 3 0 0 1 3 3.2V8"/></svg>';
  function badge(n) {
    document.querySelectorAll('a.elare-cart').forEach(function (a) {
      if (!a.querySelector('.gmc-ico')) {
        Array.prototype.slice.call(a.childNodes).forEach(function (c) { if (c.nodeType === 3) a.removeChild(c); });
        a.setAttribute('aria-label', 'Open cart');
        a.insertAdjacentHTML('afterbegin', ICON);
      }
      var b = a.querySelector('.gmc-badge');
      if (!b) { b = document.createElement('span'); b.className = 'gmc-badge'; a.appendChild(b); }
      b.textContent = n; b.style.display = n ? '' : 'none';
    });
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gmc-lock');
    q('.gmc__x').focus();
    return load();
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gmc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function toggleRefill(btn) {
    var r = refillLine(realItems());
    if (!r) return;
    btn.setAttribute('aria-busy', 'true');
    var on = !!r.line.selling_plan_allocation;
    try { if (on) sessionStorage.setItem('gwfRefillOff', '1'); else sessionStorage.removeItem('gwfRefillOff'); } catch (e) {}
    if (window.gwfTrack) window.gwfTrack('Auto-refill Toggled', { auto_refill: on ? 'off' : 'on' });
    change(r.line, { selling_plan: on ? null : r.meta.plan, properties: withNote(r.line, on ? null : refillNote(r)) }).then(function () { btn.removeAttribute('aria-busy'); });
  }

  function checkout(btn) {
    btn.disabled = true;
    if (window.gwfTrack && cart) {
      window.gwfTrack('Checkout Clicked', {
        value: cart.total_price / 100,
        bundles: realItems().map(function (i) { return i.variant_title || i.title; }).join(', '),
        auto_refill: realItems().some(function (i) { return i.selling_plan_allocation; }) ? 'on' : 'off'
      });
    }
    // Meta InitiateCheckout, AddPaymentInfo and Purchase are sent by the Customer events pixel in Shopify admin.
    window.location.href = (CFG.shopUrl || '/').replace(/\/?$/, '/') + 'checkout';
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-gmc-close]')) { if (t.closest('a[href]') && !t.closest('a[href^="/#"]')) return; close(); return; }
    if (t.closest('[data-gmc-checkout]')) { checkout(t.closest('[data-gmc-checkout]')); return; }
    if (t.closest('[data-gmc-refill-toggle]')) { toggleRefill(t.closest('[data-gmc-refill-toggle]')); return; }
    var row = t.closest('.gmc__item');
    if (!row) return;
    var line = realItems().filter(function (i) { return i.key === row.getAttribute('data-key'); })[0];
    if (!line) return;
    if (t.closest('[data-gmc-inc]')) change(line, { quantity: line.quantity + 1 });
    else if (t.closest('[data-gmc-dec]')) change(line, { quantity: line.quantity - 1 });
    else if (t.closest('[data-gmc-rm]')) change(line, { quantity: 0 });
  }

  function mount() {
    root = document.getElementById('gmc');
    if (!root) return;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    root.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a.elare-cart');
      if (!a) return;
      e.preventDefault(); e.stopImmediatePropagation(); open();
    }, true);
    window.addEventListener('gluca:welcome-unlocked', load);
    load();
  }

  window.gwfCart = { open: function () { return root ? open() : Promise.resolve(); }, reload: load };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
